/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// Automatically includes JS from the /components dirctory
import autoTemplateComponent from './core/auto-template-component'
import Menu from './utilities/header'
import Newsletter from './utilities/newsletter'
import Contents from './utilities/contents'

window.addEventListener('DOMContentLoaded', () => {
  autoTemplateComponent()
  Menu()
  Newsletter()
  Contents()
})
